import { AuthStateSelector } from '@/store/selectors';
import { useSelector } from 'react-redux';

export const useIntegrationToken = () => {
  const token = useSelector(AuthStateSelector.integrationToken);

  return {
    token,
    isValid: token !== null,
  };
};
